/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ikte",
        "-2": "ovddet beaivvi",
        "0": "odne",
        "1": "ihttin",
        "2": "don beaivve",
        "future": {
          "one": "{0} beaivve siste",
          "other": "{0} beaivve siste",
          "two": "{0} beaivve siste"
        },
        "past": {
          "one": "ikte",
          "other": "{0} beaivve dás ovdal",
          "two": "ovddet beaivve"
        }
      },
      "day-narrow": {
        "-1": "ikte",
        "-2": "ovddet beaivvi",
        "0": "odne",
        "1": "ihttin",
        "2": "don beaivve",
        "future": {
          "one": "{0} beaivve siste",
          "other": "{0} beaivve siste",
          "two": "{0} beaivve siste"
        },
        "past": {
          "one": "ikte",
          "other": "{0} beaivve dás ovdal",
          "two": "ovddet beaivve"
        }
      },
      "day-short": {
        "-1": "ikte",
        "-2": "ovddet beaivvi",
        "0": "odne",
        "1": "ihttin",
        "2": "don beaivve",
        "future": {
          "one": "{0} beaivve siste",
          "other": "{0} beaivve siste",
          "two": "{0} beaivve siste"
        },
        "past": {
          "one": "ikte",
          "other": "{0} beaivve dás ovdal",
          "two": "ovddet beaivve"
        }
      },
      "hour": {
        "0": "dán diimmu",
        "future": {
          "one": "{0} diimmu siste",
          "other": "{0} diimmu siste",
          "two": "{0} diimmu siste"
        },
        "past": {
          "one": "{0} diibmu áigi",
          "other": "{0} diimmu áigi",
          "two": "{0} diimmu áigi"
        }
      },
      "hour-narrow": {
        "0": "dán diimmu",
        "future": {
          "one": "{0} dmu siste",
          "other": "{0} dmu siste",
          "two": "{0} diimmu siste"
        },
        "past": {
          "one": "{0} dmu áigi",
          "other": "{0} dmu áigi",
          "two": "{0} diimmu áigi"
        }
      },
      "hour-short": {
        "0": "dán diimmu",
        "future": {
          "one": "{0} dmu siste",
          "other": "{0} dmu siste",
          "two": "{0} diimmu siste"
        },
        "past": {
          "one": "{0} dmu áigi",
          "other": "{0} dmu áigi",
          "two": "{0} diimmu áigi"
        }
      },
      "minute": {
        "0": "dán minuhta",
        "future": {
          "one": "{0} minuhta siste",
          "other": "{0} minuhta siste",
          "two": "{0} minuhta siste"
        },
        "past": {
          "one": "{0} minuhtta áigi",
          "other": "{0} minuhta áigi",
          "two": "{0} minuhta áigi"
        }
      },
      "minute-narrow": {
        "0": "dán minuhta",
        "future": {
          "one": "{0} min. siste",
          "other": "{0} min. siste",
          "two": "{0} minuhta siste"
        },
        "past": {
          "one": "{0} min. áigi",
          "other": "{0} min. áigi",
          "two": "{0} minuhta áigi"
        }
      },
      "minute-short": {
        "0": "dán minuhta",
        "future": {
          "one": "{0} min. siste",
          "other": "{0} min. siste",
          "two": "{0} minuhta siste"
        },
        "past": {
          "one": "{0} min. áigi",
          "other": "{0} min. áigi",
          "two": "{0} minuhta áigi"
        }
      },
      "month": {
        "-1": "mannan mánu",
        "0": "dán mánu",
        "1": "boahtte mánu",
        "future": {
          "one": "{0} mánu siste",
          "other": "{0} mánu siste",
          "two": "{0} mánu siste"
        },
        "past": {
          "one": "{0} mánnu dás ovdal",
          "other": "{0} mánu dás ovdal",
          "two": "{0} mánu dás ovdal"
        }
      },
      "month-narrow": {
        "-1": "mannan mánu",
        "0": "dán mánu",
        "1": "boahtte mánu",
        "future": {
          "one": "{0} mánu geahčen",
          "other": "{0} mánu geahčen",
          "two": "{0} mánu geahčen"
        },
        "past": {
          "one": "{0} mánnu dás ovdal",
          "other": "{0} mánu dás ovdal",
          "two": "{0} mánu dás ovdal"
        }
      },
      "month-short": {
        "-1": "mannan mánu",
        "0": "dán mánu",
        "1": "boahtte mánu",
        "future": {
          "one": "{0} mánu siste",
          "other": "{0} mánu siste",
          "two": "{0} mánu siste"
        },
        "past": {
          "one": "{0} mánnu dás ovdal",
          "other": "{0} mánu dás ovdal",
          "two": "{0} mánu dás ovdal"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "mannan njealjádasjagi",
        "0": "dán njealjádasjagi",
        "1": "boahtte njealjádasjagi",
        "future": {
          "one": "čuovvovaš {0} njealjádasjagi",
          "other": "čuovvovaš {0} njealjádasjagi",
          "two": "čuovvovaš {0} njealjádasjagi"
        },
        "past": {
          "one": "-{0} njealjádasjagi dás ovdal",
          "other": "-{0} njealjádasjagi dás ovdal",
          "two": "-{0} njealjádasjagi dás ovdal"
        }
      },
      "quarter-narrow": {
        "-1": "mannan njealjádasjagi",
        "0": "dán njealjádasjagi",
        "1": "boahtte njealjádasjagi",
        "future": {
          "one": "boahtte {0} njealj.j.",
          "other": "boahtte {0} njealj.j.",
          "two": "boahtte {0} njealjádasjagi"
        },
        "past": {
          "one": "{0} njealj.j. dás ovdal",
          "other": "{0} njealj.j. dás ovdal",
          "two": "-{0} njealjádasjagi dás ovdal"
        }
      },
      "quarter-short": {
        "-1": "mannan njealjádasjagi",
        "0": "dán njealjádasjagi",
        "1": "boahtte njealjádasjagi",
        "future": {
          "one": "boahtte {0} njealj.j.",
          "other": "boahtte {0} njealj.j.",
          "two": "boahtte {0} njealjádasjagi"
        },
        "past": {
          "one": "{0} njealj.j. dás ovdal",
          "other": "{0} njealj.j. dás ovdal",
          "two": "{0} njealjádasjagi dás ovdal"
        }
      },
      "second": {
        "0": "dál",
        "future": {
          "one": "{0} sekundda siste",
          "other": "{0} sekundda siste",
          "two": "{0} sekundda siste"
        },
        "past": {
          "one": "{0} sekunda áigi",
          "other": "{0} sekundda áigi",
          "two": "{0} sekundda áigi"
        }
      },
      "second-narrow": {
        "0": "dál",
        "future": {
          "one": "{0} sek. siste",
          "other": "{0} sek. siste",
          "two": "{0} sekundda siste"
        },
        "past": {
          "one": "{0} sek. áigi",
          "other": "{0} sek. áigi",
          "two": "{0} sekundda áigi"
        }
      },
      "second-short": {
        "0": "dál",
        "future": {
          "one": "{0} sek. siste",
          "other": "{0} sek. siste",
          "two": "{0} sekundda siste"
        },
        "past": {
          "one": "{0} sek. áigi",
          "other": "{0} sek. áigi",
          "two": "{0} sekundda áigi"
        }
      },
      "week": {
        "-1": "mannan vahku",
        "0": "dán vahku",
        "1": "boahtte vahku",
        "future": {
          "one": "{0} vahku geahčen",
          "other": "{0} vahku geahčen",
          "two": "{0} vahku geahčen"
        },
        "past": {
          "one": "{0} vahkku dás ovdal",
          "other": "{0} vahku dás ovdal",
          "two": "{0} vahku dás ovdal"
        }
      },
      "week-narrow": {
        "-1": "mannan vahku",
        "0": "dán vahku",
        "1": "boahtte vahku",
        "future": {
          "one": "{0} v(k) geahčen",
          "other": "{0} v(k) geahčen",
          "two": "{0} v(k) geahčen"
        },
        "past": {
          "one": "{0} vahkku dás ovdal",
          "other": "{0} v(k) dás ovdal",
          "two": "{0} vahku dás ovdal"
        }
      },
      "week-short": {
        "-1": "mannan vahku",
        "0": "dán vahku",
        "1": "boahtte vahku",
        "future": {
          "one": "{0} v(k) siste",
          "other": "{0} v(k) siste",
          "two": "{0} vahku siste"
        },
        "past": {
          "one": "{0} v(k) dás ovdal",
          "other": "{0} v(k) dás ovdal",
          "two": "{0} vahku dás ovdal"
        }
      },
      "year": {
        "-1": "diibmá",
        "0": "dán jagi",
        "1": "boahtte jagi",
        "future": {
          "one": "{0} jagi siste",
          "other": "{0} jagi siste",
          "two": "{0} jagi siste"
        },
        "past": {
          "one": "diibmá",
          "other": "{0} jagi dás ovdal",
          "two": "ovddet jagi"
        }
      },
      "year-narrow": {
        "-1": "diibmá",
        "0": "dán jagi",
        "1": "boahtte jagi",
        "future": {
          "one": "{0} jagi siste",
          "other": "{0} jagi siste",
          "two": "{0} jagi siste"
        },
        "past": {
          "one": "{0} j. dás ovdal",
          "other": "{0} j. dás ovdal",
          "two": "{0} jagi dás ovdal"
        }
      },
      "year-short": {
        "-1": "diibmá",
        "0": "dán jagi",
        "1": "boahtte jagi",
        "future": {
          "one": "{0} j. siste",
          "other": "{0} j. siste",
          "two": "{0} jagi siste"
        },
        "past": {
          "one": "diibmá",
          "other": "{0} j. dás ovdal",
          "two": "ovddet jagi"
        }
      }
    },
    "locale": "se-FI"
  });
}